import React from "react";
import { createColumnHelper, sortingFns } from "@tanstack/react-table";
import { compareItems } from "@tanstack/match-sorter-utils";

const handleClick = (e) => {
    e.stopPropagation(); // Empêche la propagation de l'événement de clic
};

const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
        const defaultRef = React.useRef();
        const resolvedRef = ref || defaultRef;

        React.useEffect(() => {
            resolvedRef.current.indeterminate = indeterminate;
        }, [resolvedRef, indeterminate]);

        return (
            <>
                <input type="checkbox" className="checkbox checkbox-sm checkbox-primary" ref={resolvedRef} {...rest} onClick={handleClick} />
            </>
        );
    }
);

const createColumns = (columnDefs) => {
    const columnHelper = createColumnHelper();
    return columnDefs.map((columnDef) => {
        // console.log('columnDef', columnDef)
        // console.log('columnHelper', columnHelper)
        return columnHelper.accessor(row => row[columnDef.id], {
            id: columnDef.id, // this is the unique id for the column
            cell: info => info.getValue(),
            header: () => <span>{columnDef.header}</span>,
            footer: props => props.column.id,
            ...columnDef
        })
    });
}

const createColumnsWithCheckbox = () => {
    return {
        id: 'select',
        header: ({ table }) => (
            <IndeterminateCheckbox
                {...{
                    checked: table.getIsAllRowsSelected(),
                    indeterminate: table.getIsSomeRowsSelected(),
                    onChange: table.getToggleAllRowsSelectedHandler(),
                }}
            />
        ),
        cell: ({ row }) => (
            <div onClick={handleClick} className="px-1">
                <IndeterminateCheckbox
                    {...{
                        checked: row.getIsSelected(),
                        disabled: !row.getCanSelect(),
                        indeterminate: row.getIsSomeSelected(),
                        onChange: row.getToggleSelectedHandler(),
                    }}
                />
            </div>
        ),
        footer: () => null,
        enableResizing: false, //disable resizing for just this column
        size: 20, //starting column size
    }
}

const getCorrectPageCount = (total, pageSize) => {
    const hasRest = (total % pageSize) > 0
    return parseInt((hasRest ? (total / pageSize) + 1 : total / pageSize))

}

const getColumsVisibility = (defs) => {

    return defs.reduce((acc, column) => {
        if (column.hideByDefault) {
            acc[column.id] = false
        } else {
            acc[column.id] = true
        }
        return acc
    }, {})
}

export { createColumns, createColumnsWithCheckbox, getCorrectPageCount, getColumsVisibility }
